import { render, staticRenderFns } from "./CompilationsPage.vue?vue&type=template&id=1255ee2f&scoped=true&"
import script from "./CompilationsPage.vue?vue&type=script&lang=ts&"
export * from "./CompilationsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CompilationsPage.vue?vue&type=style&index=0&id=1255ee2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1255ee2f",
  null
  
)

export default component.exports